module.exports = __webpack_public_path__ + "img/sarpras-drawer.628f976a.png";